export class AplicarRegraCampos {

  public static aplicar(campos: any, formulario: any) {
    for (const campo of campos) {
      const formControl = formulario.get(campo.control);

      if (!campo.regra(formControl.value)) {
        formControl.setErrors({ invalid: true });
        formControl.markAsTouched();
        alert(campo.mensagem);
        return;
      }
    }
  }
}
